'use client'

import { motion } from 'framer-motion'

export default function Loader() {
  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-white bg-opacity-50'>
      <motion.div
        className='w-16 h-16 border-4 border-t-transparent border-blue rounded-full animate-spin'
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        exit={{ scale: 0 }}
        transition={{ duration: 0.3 }}
      />
    </div>
  )
}
